import { gql } from '@apollo/client';

export const FETCH_REBALANCE_TIMESTAMP = gql`
  query fetchRebalanceTimestamp($rebalanceId: ObjectID!) {
    fetchRebalance(rebalanceId: $rebalanceId) {
      rebalance {
        createdAt
      }
    }
  }
`;
